import React,{ useEffect } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ServiceEdit1 from "./Components/ServiceEdit1";
import Loader from "./Components/Loader";

const ServiceEditPage1=()=>{
    useEffect(()=>{
        document.title="Edit Service | Janushree"
      },[]);

    return(
        <>
            <Header/>
            <ServiceEdit1/>
            <Loader/>
            <Footer/>
        </>
    );
}

export default ServiceEditPage1;